// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NAOJ","colMin":"styles_colMin__1Elns"};